<div class="bulk_import_content">
    <div class="row">
        <div class="col-lg-6 mb-4">
            <a>
                <span class="" (click)="Uploadcsv()" class="cursor-pointer">
                    <span class="fa fa-upload"></span> Import Manual Update
                    <i *ngIf="isUploadLoader" class="fa fa-circle-o-notch fa-spin"
                        style="font-size: .875rem; line-height: 1.5;"></i>
                </span>
            </a>
            <input accept=".xls,.xlsx" #myInput (change)="filechange($event)" type="file" style="display: none"
                id="csvimport" name="csvimport" required />
            <ng-container *ngIf="isFileShow">
                <div class="file-div text-center file-div-position">
                    <span class="cursor-pointer">
                        <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
                    </span>
                    <div class="data-div">{{this.fileName}}</div>
                </div>
            </ng-container>
        </div>
        <div class="col-lg-6 text-right cursor-pointer text-primary">
                <span (click)="downloadImportTemplate()"><span class="fa fa-download"></span> Download Import Template</span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="data-value" *ngIf="!isShowTable">
                <h3>No Data Available</h3>
            </div>
            <table *ngIf="isShowTable" class="import-table">
                <thead>
                    <td>No</td>
                    <td>Geography*</td>
                    <td>Country*</td>
                    <td>Regulator*</td>
                    <td>Publish Date*</td>
                    <td>Type*</td>
                    <td>Title*</td>
                    <td>Description*</td>
                    <td>Publication Link*</td>
                    <td>Topics*</td>
                </thead>
                <tbody>
                    <tr *ngFor="let item of manualUpdateList;let i = index;">
                        <td> {{i+1}}</td>
                        <td [ngClass]="item.isGeographyValid==true? '' : 'error_class'">{{item.geography}}</td>
                        <td [ngClass]="item.isCountryValid==true? '' : 'error_class'">{{item.country}}</td>
                        <td [ngClass]="item.isRegulatorValid==true? '' : 'error_class'">{{item.regulator}}</td>
                        <td [ngClass]="item.isPublishDateValid==true? '' : 'error_class'">{{item.publishDate | date:
                            'dd/MM/yyyy'}}</td>
                        <td [ngClass]="item.isPubTypeValid==true? '' : 'error_class'">{{item.pubType}}</td>
                        <td [ngClass]="item.isTitleValid==true? '' : 'error_class'">{{item.title}}</td>
                        <td [ngClass]="item.isDescriptionValid==true? '' : 'error_class'">{{item.description}}</td>
                        <td [ngClass]="item.isHyperlinkValid==true? '' : 'error_class'">{{item.hyperlink}}</td>
                        <td [ngClass]="item.isRuleTopicValid==true? '' : 'error_class'">{{item.ruleTopic}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- <div class="row">
    <div class="offset-lg-6 col-lg-6 text-right mt-4" *ngIf="isShowErrorMessage">
        <div class="alert alert-danger">
            <p>Data Validation Error: Please check the highlighted fields. </p>
            <p>(Only alphanumeric input is allowed. Max character limit for Geography, Country and Regulator is 50.)</p>
        </div>
    </div>
</div> -->